export const VehicleTransferConsumerSceneTranslation = {
  fi: {
    VehicleTransferConsumerScene: {
      title: 'Siirrä ajoneuvo käyttäjälle',
    },
  },
};
